var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49561 0.7504L4.74339 3.89548C5.08553 4.22935 5.08553 4.77065 4.74339 5.10452L1.4956 8.2496C1.15346 8.58347 0.598744 8.58347 0.256603 8.2496C-0.0855371 7.91573 -0.085537 7.37442 0.256604 7.04056L2.88489 4.5L0.256605 1.95944C-0.0855358 1.62557 -0.0855357 1.08427 0.256605 0.7504C0.598746 0.416532 1.15347 0.416532 1.49561 0.7504Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7b197c70a1213843ed369cf16957b971.svg";
export { ForwardRef as ReactComponent };